// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.sign-up-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}

.sign-up-form__steps {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.sign-up-form__step {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid #d6e4ff;
  border-radius: 12px;
  background: #f8faff;
  color: #667085;
  transition: all 0.2s ease;
  min-width: 0;
}

.sign-up-form__step.is-active {
  border-color: #1677ff;
  background: #eef4ff;
  color: #1d4ed8;
}

.sign-up-form__step.is-complete {
  border-color: #52c41a;
  background: #f6ffed;
  color: #389e0d;
}

.sign-up-form__step-index {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  color: inherit;
  border: 1px solid currentColor;
}

.sign-up-form__step-label {
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  word-break: break-word;
}

.sign-up-form__section {
  border: 1px solid #e6edf8;
  border-radius: 16px;
  padding: 16px;
  background: #fbfdff;
}

.sign-up-form__section--single {
  background: #ffffff;
}

.sign-up-form__section-title {
  margin: 0 0 12px;
  color: #1d2939;
  font-size: 16px;
  font-weight: 700;
}

.sign-up-form__section-title--spaced {
  margin-top: 18px;
}

.sign-up-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.sign-up-form__stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sign-up-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sign-up-form__field--full {
  grid-column: 1/-1;
}

.sign-up-form__label {
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}

.sign-up-form__required-mark {
  color: #ff0000;
  margin-left: 4px;
  font-weight: 700;
}

.sign-up-form__label--inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sign-up-form__hint {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.sign-up-form__hint .anticon {
  font-size: 14px;
}

.sign-up-form__input {
  min-height: 46px;
  border-radius: 10px !important;
  border-color: #cfdaf0;
}

.sign-up-form__input:hover {
  border-color: #91b8ff;
}

.sign-up-form__input.ant-input-affix-wrapper-focused,
.sign-up-form__input:focus,
.sign-up-form__input:focus-within {
  border-color: #1677ff;
  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.14);
}

.sign-up-form__input .ant-input {
  font-size: 14px;
}

.sign-up-form__input--error {
  border-color: #ff4d4f !important;
  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15);
}

.sign-up-form__select {
  width: 100%;
}

.sign-up-form__select .ant-select-selector {
  min-height: 42px !important;
  border-radius: 10px !important;
  border-color: #cfdaf0 !important;
  display: flex;
  align-items: center;
}

.sign-up-form__select.ant-select-focused .ant-select-selector,
.sign-up-form__select:hover .ant-select-selector {
  border-color: #1677ff !important;
}

.sign-up-form__select--error.ant-select .ant-select-selector,
.sign-up-form__select--error.ant-select:hover .ant-select-selector,
.sign-up-form__select--error.ant-select.ant-select-focused .ant-select-selector {
  border: 1px solid #ff4d4f !important;
  border-color: #ff4d4f !important;
  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15) !important;
}

.sign-up-form__icon-button {
  color: #98a2b3;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
}

.sign-up-form__icon-button:hover {
  color: #ff4d4f;
}

.sign-up-form__add-button {
  width: 100%;
  border-radius: 10px !important;
  font-weight: 600;
}

.sign-up-form__error {
  margin: 0;
  font-size: 12px;
  color: #ff4d4f;
}

.sign-up-form__submit {
  min-height: 48px;
  border-radius: 12px !important;
  font-size: 15px;
  font-weight: 600;
}

.sign-up-form__submit .ant-spin-dot-item {
  background-color: #ffffff;
}

.sign-up-form__meta {
  margin: 0;
  text-align: center;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.sign-up-form__meta a {
  color: #1677ff;
  font-weight: 600;
  text-decoration: none;
}

.sign-up-form__meta a:hover {
  text-decoration: underline;
}

.sign-up-form__meta--secondary {
  margin-top: -8px;
}

@media screen and (max-width: 767px) {
  .sign-up-form {
    gap: 16px;
  }
  .sign-up-form__steps {
    gap: 8px;
  }
  .sign-up-form__grid {
    grid-template-columns: 1fr;
  }
  .sign-up-form__section {
    padding: 14px 12px;
  }
  .sign-up-form__submit {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}
@media screen and (max-width: 575px) {
  .sign-up-form__steps {
    grid-template-columns: 1fr;
  }
  .sign-up-form__step {
    padding: 8px 10px;
  }
  .sign-up-form__step-label {
    font-size: 11px;
  }
  .sign-up-form__section {
    padding: 12px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/SignUp.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAEF;;AAAA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAIF;;AAFA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAKF;;AAHA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAMF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,8BAAA;AAOF;;AALA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AAQF;;AANA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AASF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAWF;;AATA;EACE,gBAAA;AAYF;;AAVA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAaF;;AAXA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAcF;;AAZA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAeF;;AAbA;EACE,iBAAA;AAgBF;;AAdA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAiBF;;AAfA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAoBF;;AAlBA;EACE,eAAA;AAqBF;;AAnBA;EACE,gBAAA;EACA,8BAAA;EACA,qBAAA;AAsBF;;AApBA;EACE,qBAAA;AAuBF;;AArBA;;;EAGE,qBAAA;EACA,8CAAA;AAwBF;;AAtBA;EACE,eAAA;AAyBF;;AAvBA;EACE,gCAAA;EACA,6CAAA;AA0BF;;AAxBA;EACE,WAAA;AA2BF;;AAzBA;EACE,2BAAA;EACA,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AA4BF;;AA1BA;;EAEE,gCAAA;AA6BF;;AA3BA;;;EAGE,oCAAA;EACA,gCAAA;EACA,wDAAA;AA8BF;;AA5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA+BF;;AA7BA;EACE,cAAA;AAgCF;;AA9BA;EACE,WAAA;EACA,8BAAA;EACA,gBAAA;AAiCF;;AA/BA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAkCF;;AAhCA;EACE,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAmCF;;AAjCA;EACE,yBAAA;AAoCF;;AAlCA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqCF;;AAnCA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAsCF;;AApCA;EACE,0BAAA;AAuCF;;AArCA;EACE,gBAAA;AAwCF;;AAtCA;EACE;IACE,SAAA;EAyCF;EAvCA;IACE,QAAA;EAyCF;EAvCA;IACE,0BAAA;EAyCF;EAvCA;IACE,kBAAA;EAyCF;EAvCA;IACE,gBAAA;IACA,SAAA;IACA,UAAA;EAyCF;AACF;AAxCA;EACE;IACE,0BAAA;EA0CF;EAxCA;IACE,iBAAA;EA0CF;EAxCA;IACE,eAAA;EA0CF;EAxCA;IACE,kBAAA;EA0CF;AACF","sourcesContent":[".sign-up-loading\n  display: flex\n  justify-content: center\n  padding: 24px 0\n\n.sign-up-form\n  display: flex\n  flex-direction: column\n  gap: 18px\n  width: 100%\n\n.sign-up-form__steps\n  display: grid\n  grid-template-columns: repeat(2, minmax(0, 1fr))\n  gap: 10px\n\n.sign-up-form__step\n  display: flex\n  align-items: center\n  gap: 8px\n  padding: 9px 12px\n  border: 1px solid #d6e4ff\n  border-radius: 12px\n  background: #f8faff\n  color: #667085\n  transition: all 0.2s ease\n  min-width: 0\n\n.sign-up-form__step.is-active\n  border-color: #1677ff\n  background: #eef4ff\n  color: #1d4ed8\n\n.sign-up-form__step.is-complete\n  border-color: #52c41a\n  background: #f6ffed\n  color: #389e0d\n\n.sign-up-form__step-index\n  width: 22px\n  height: 22px\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  border-radius: 50%\n  font-size: 12px\n  font-weight: 700\n  color: inherit\n  border: 1px solid currentColor\n\n.sign-up-form__step-label\n  font-size: 12px\n  font-weight: 600\n  min-width: 0\n  word-break: break-word\n\n.sign-up-form__section\n  border: 1px solid #e6edf8\n  border-radius: 16px\n  padding: 16px\n  background: #fbfdff\n\n.sign-up-form__section--single\n  background: #ffffff\n\n.sign-up-form__section-title\n  margin: 0 0 12px\n  color: #1d2939\n  font-size: 16px\n  font-weight: 700\n\n.sign-up-form__section-title--spaced\n  margin-top: 18px\n\n.sign-up-form__grid\n  display: grid\n  grid-template-columns: repeat(2, minmax(0, 1fr))\n  gap: 12px\n\n.sign-up-form__stack\n  display: flex\n  flex-direction: column\n  gap: 10px\n\n.sign-up-form__field\n  display: flex\n  flex-direction: column\n  gap: 6px\n\n.sign-up-form__field--full\n  grid-column: 1 / -1\n\n.sign-up-form__label\n  color: #344054\n  font-size: 13px\n  font-weight: 600\n\n.sign-up-form__required-mark\n  color: #ff0000\n  margin-left: 4px\n  font-weight: 700\n\n.sign-up-form__label--inline\n  display: flex\n  align-items: center\n  gap: 6px\n\n.sign-up-form__hint\n  width: 18px\n  height: 18px\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  color: #94a3b8\n\n.sign-up-form__hint .anticon\n  font-size: 14px\n\n.sign-up-form__input\n  min-height: 46px\n  border-radius: 10px !important\n  border-color: #cfdaf0\n\n.sign-up-form__input:hover\n  border-color: #91b8ff\n\n.sign-up-form__input.ant-input-affix-wrapper-focused,\n.sign-up-form__input:focus,\n.sign-up-form__input:focus-within\n  border-color: #1677ff\n  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.14)\n\n.sign-up-form__input .ant-input\n  font-size: 14px\n\n.sign-up-form__input--error\n  border-color: #ff4d4f !important\n  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15)\n\n.sign-up-form__select\n  width: 100%\n\n.sign-up-form__select .ant-select-selector\n  min-height: 42px !important\n  border-radius: 10px !important\n  border-color: #cfdaf0 !important\n  display: flex\n  align-items: center\n\n.sign-up-form__select.ant-select-focused .ant-select-selector,\n.sign-up-form__select:hover .ant-select-selector\n  border-color: #1677ff !important\n\n.sign-up-form__select--error.ant-select .ant-select-selector,\n.sign-up-form__select--error.ant-select:hover .ant-select-selector,\n.sign-up-form__select--error.ant-select.ant-select-focused .ant-select-selector\n  border: 1px solid #ff4d4f !important\n  border-color: #ff4d4f !important\n  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15) !important\n\n.sign-up-form__icon-button\n  color: #98a2b3\n  width: 36px\n  height: 36px\n  min-width: 36px\n  min-height: 36px\n\n.sign-up-form__icon-button:hover\n  color: #ff4d4f\n\n.sign-up-form__add-button\n  width: 100%\n  border-radius: 10px !important\n  font-weight: 600\n\n.sign-up-form__error\n  margin: 0\n  font-size: 12px\n  color: #ff4d4f\n\n.sign-up-form__submit\n  min-height: 48px\n  border-radius: 12px !important\n  font-size: 15px\n  font-weight: 600\n\n.sign-up-form__submit .ant-spin-dot-item\n  background-color: #ffffff\n\n.sign-up-form__meta\n  margin: 0\n  text-align: center\n  color: #667085\n  font-size: 14px\n  line-height: 1.5\n\n.sign-up-form__meta a\n  color: #1677ff\n  font-weight: 600\n  text-decoration: none\n\n.sign-up-form__meta a:hover\n  text-decoration: underline\n\n.sign-up-form__meta--secondary\n  margin-top: -8px\n\n@media screen and (max-width: 767px)\n  .sign-up-form\n    gap: 16px\n\n  .sign-up-form__steps\n    gap: 8px\n\n  .sign-up-form__grid\n    grid-template-columns: 1fr\n\n  .sign-up-form__section\n    padding: 14px 12px\n\n  .sign-up-form__submit\n    position: sticky\n    bottom: 0\n    z-index: 1\n\n@media screen and (max-width: 575px)\n  .sign-up-form__steps\n    grid-template-columns: 1fr\n\n  .sign-up-form__step\n    padding: 8px 10px\n\n  .sign-up-form__step-label\n    font-size: 11px\n\n  .sign-up-form__section\n    padding: 12px 10px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
